module.exports = __webpack_public_path__ + "img/ic-copy-code.svg";